export { default } from './PromoterHeaderMinimal';